'use strict';

// import 'intl-tel-input';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/
};

var currencies = '\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6';

// global form validator settings
var settings = {
    showErrors: function(errorMap, errorList) {
        $.each(errorList, function(index, item){
            var $element = $(item.element);

            if($element[0].nodeName === 'SELECT') {
                $element.parent().next().addClass('error');
            }
        });

        this.defaultShowErrors();     // to display the default error placement
    },
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        var $element = $(element),
            $clearCCDetailsField = $('#isClearCCDetails');

        if ($clearCCDetailsField && $clearCCDetailsField.val() === 'false') {
            if ($element.hasClass('input-select') && ($element.closest('.month').length > 0 || $element.closest('.year').length > 0)) {
                return;
            }
        }

        if (!this.checkable(element) && !$element.hasClass('modal--signup__emailsignup')) {
            this.element(element);
        }

        // add or remove error class from selectric drop down wrapper
        if($element[0].nodeName === 'SELECT') {
            if($element.hasClass('error')) {
                $element.parent().next().addClass('error');
            } else {
                $element.parent().next().removeClass('error');
            }
        }
    },
    errorPlacement: placeError
};

/**
 * [placeError] Customizing placement of created error labels to insert the error for
 * <select> tags after their styled wrapped.
 * @param  {[type]} jQuery object [The error label to insert into the DOM.]
 * @param  {[type]} jQuery object [The validated input, for relative positioning.]
 */
function placeError(error, $element){
    if($element[0].nodeName === 'SELECT' || $element.hasClass('input-multicheckbox')){
        $element = $element.closest('.field-wrapper')[0] || $element.parent();
    } 

    error.insertAfter($element);
}

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
// var validatePhone = function (value, el) {
//     var country = $(el).closest('form').find('.country');

//     if(/[a-zA-Z]/.test(value.trim())) {
//         return false;
//     }

//     if (country.length === 0 || country.val().length === 0 || !regex.phone[country.val().toLowerCase()]) {
//         return true;
//     }

//     var rgx = regex.phone[country.val().toLowerCase()];
//     var isOptional = this.optional(el);
//     var isValid = rgx.test($.trim(value));

//     return isOptional || isValid;
// };

var validatePhone2 = function (value, element) {
    var $element = $(element);

	if ($.trim($element.val())) {
		if ($element.intlTelInput('isValidNumber') === false ) {
			return false;
		} else {
			return true;
		}
	}
};

var validatePostal = function (value) {
    
    var trimmed = value.trim();

    return trimmed  === '' || /^[a-zA-Z0-9\-_. ]+$/.test(trimmed) ? true : false;
};

var validateCvn = function (value) {
	moengagePaymentPushEvent('payment_credit_card');
    return /^[0-9\*-_]+$/.test(value.trim());
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};

function matchFields(originalClass, confirmClass, value, field){
    var dependentField = field.form.querySelector( '.' + (field.classList.contains(originalClass) ? confirmClass : originalClass) ),
        fieldsMatch = field.value == dependentField.value;

    return dependentField.value == '' || fieldsMatch;
}


/**
 * Validates that value is an ASCII character plus certain language specific codes
 */
function validateASCII(value) {
    // console.log(value);
    //return value.trim() === '' || /^[\x00-\x7FÀ-úÀ-ÿ¡¿≤≥÷”’»—º‚\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]+$/.test(value.trim());
    var regex = /^[\u0621-\u064A\u0660-\u0669a-zA-Z0-9\x00-\x7FÀ-úÀ-ÿ¡¿≤≥÷”’»—º‚\u0000-\u024F]+$/; 
    
    // allow Latin only    
    return value.trim() === '' || regex.test(value.trim());
}

/**
 * Validates that value has Emojis 
 */

function validateEmoji(value) {
    return value.trim() === '' || !/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(value.trim());
}

/**
 * Validate name
 * - Numbers are not allowed
 * - Spaces only are not allowed
 * - There are should be at least one symbol from English alphabet or accent
 * @param {String} value
 * @returns {Boolean}
 */
function validateName(value) {
    var regex = /[\u0621-\u064A\u0660-\u0669a-zA-Z\u00C0-\u017F]+/; 
   
    return value === '' || (validateASCII(value) && !/\d/.test(value) && !/^\s+$/.test(value) && regex.test(value) && !/[!~@#$^*()_+=[\]{}|\\,.?:-]/.test(value)); 
}

/**
 * Validate name length
 * @param {String} value
 * @returns {Boolean}
 */
function validateNameLength(value) {
    return value === '' || value.trim().length >= 2;
}

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
// $.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);
$.validator.addMethod('phone', validatePhone2, Resources.INVALID_PHONE);


/**
 * Add postal validation method to jQuery validation plugin.
 * Text fields must have 'postal' css class to be validated as postal
 */
$.validator.addMethod('postal', validatePostal, Resources.INVALID_ZIP);

/**
 * Add CVN validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated as CVN
 */
$.validator.addMethod('cvn', validateCvn, Resources.VALIDATE_CVN);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add ASCII validation method to jQuery validation plugin.
 * Text fields must have 'validate-char' css class to be validated as not a credit card
 */
$.validator.addMethod('validate-char', validateASCII, Resources.VALIDATE_CHARACTERS);

/**
 * Add emoji validation method to jQuery validation plugin.
 * Text fields must have 'validate-emoji' css class to be validated
 */
 $.validator.addMethod('validate-emoji', validateEmoji, Resources.VALIDATE_EMOJIS);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, Resources.VALIDATE_NUMBER); // '' should be replaced with error message if needed

// Name validation has to display different messages for different circumstances. Because of this it is divided in 3 validators:
// "validate-name": common validator
// "validate-first-name-length": name length validator with own message for first name
// "validate-last-name-length": name length validator with own message for last name
/**
 * Add name field validation
 */
$.validator.addMethod('validate-name', validateName, Resources.VALIDATE_NAME);

/**
 * Add first name length field validation
 */
$.validator.addMethod('validate-first-name-length', validateNameLength, Resources.VALIDATE_FIRST_NAME_LENGTH);

/**
 * Add last name length field validation
 */
$.validator.addMethod('validate-last-name-length', validateNameLength, Resources.VALIDATE_LAST_NAME_LENGTH);

/**
 * Check if confirmation element matches the original on blur.
 * @param  {[type]} confirmEl [description]
 */
function confirmOriginalMatch(confirmEl) {
    if(confirmEl.value !== '') {
        $(confirmEl).valid();
    }
}

/**
 * Better field match validation. New 'matches' validation can be implemented by
 * just adding a new object to the matchValidations array
 */

var matchValidations = [
        {
            type: 'email',
            error: Resources.VALIDATE_EMAILMATCH
        },
        {
            type: 'password',
            error: Resources.VALIDATE_PASSMATCH
        }
    ];

matchValidations.forEach(function(match){
    var validationType  = 'validate-'+ match.type +'-match',
        originalClass   = 'original-' + match.type,
        confirmClass    = 'confirm-' + match.type,
        originalEl      = document.querySelector('.' + originalClass),
        confirmEl       = document.querySelector('.' + confirmClass);

    if(!originalEl) {
        return false;
    }

    originalEl.addEventListener('blur', confirmOriginalMatch.bind(this, confirmEl));
    $.validator.addMethod(validationType, matchFields.bind(this, originalClass, confirmClass), match.error);
});

/**
 * Add better email address validation
 */
$.validator.addMethod('validate-strict-email', function (value, el) {
    return value == '' || /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i.test(value)

}, Resources.VALIDATE_EMAIL);


/**
 * This function validates atleast one user interest is selected. 
 */
 $.validator.addMethod('validate-user-interests', function (value, element) {
    return $('input[name="' + element.name + '"]:checked').length > 0;
}, Resources.VALIDATE_USER_INTEREST);

$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
    regex: regex,
    settings: settings,
    init: function () {
        var self = this;

        $('form .form-row').find('input, select, textarea').on('change.unsetBEError', function(){
            var $rowError       = $(this).closest('.form-row.error'),
                $backendError   = $rowError.find('.form-caption.error-message');

            if($rowError.length && $backendError.length) {
                $rowError.removeClass('error');
                $backendError.remove();
            }
        });

        $('form:not(.suppress)').each(function () {
            $(this).validate(self.settings);
        });
    },
    initForm: function (f, s) {
        $(f).validate(s || this.settings);
    }
};

function getRequestLocale() {
    if (window.GlobalAttributes.LANGUAGE !== undefined && window.GlobalAttributes.hasOwnProperty('LANGUAGE')) {
        return window.GlobalAttributes.LANGUAGE.toLowerCase();
    } else if (window.locale !== undefined) {
        return window.locale;
    }
}

module.exports = validator;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/validator.js